import { createContext, MutableRefObject } from "react";
import { BusinessPartnerListForBcBeta } from "src/entity/recon-entity/ReconInterfaces";
import { BranchInfo, CompanyInfo } from "../../CommonLegacy/CommonComponents";
import { BcNewFilterType } from "./BcNewFilter";

export interface IBcNewContext {
  tabValue: number;
  setTabValue: StateDispatch<number>;
  tabChipLabel: { [k in keyof typeof TABS_MAP]: number };
  setTabChipLabel: StateDispatch<{ [k in keyof typeof TABS_MAP]: number }>;
  loader: boolean;
  rowsDataBcBeta: BusinessPartnerListForBcBeta[];
  setRowsDataBcBeta: StateDispatch<BusinessPartnerListForBcBeta[]>;
  allRowsData: MutableRefObject<BusinessPartnerListForBcBeta[]>;
  rowsDataBcNewMailing: BusinessPartnerListForBcBeta[];
  setRowsDataBcNewMailing: StateDispatch<BusinessPartnerListForBcBeta[]>;
  allRowsDataMailing: MutableRefObject<BusinessPartnerListForBcBeta[]>;
  storeAllCategories: MutableRefObject<string[]>;
  currentRow: BusinessPartnerListForBcBeta;
  setCurrentRow: StateDispatch<BusinessPartnerListForBcBeta>;
  mailingRows: BusinessPartnerListForBcBeta[];
  syncMail: () => void;
  setMailingRows: StateDispatch<BusinessPartnerListForBcBeta[]>;
  openBcBetaMailThread: boolean;
  setOpenBcBetaMailThread: StateDispatch<boolean>;
  openBcNewMailing: boolean;
  setOpenBcNewMailing: StateDispatch<boolean>;
  activeStep: number;
  setActiveStep: StateDispatch<number>;
  openRaiseReq: boolean;
  setOpenRaiseReq: StateDispatch<boolean>;
  withoutTemplateCheck: boolean;
  setWithoutTemplateCheck: StateDispatch<boolean>;
  // Sync Mail Status
  isSyncingMailStatus: boolean;
  setIsSyncingMailStatus: StateDispatch<boolean>;
  lastMailSyncStatusDate: Date;
  getSyncMailStatus: () => void;
  setLastMailSyncStatusDate: StateDispatch<Date>;
  listAllBusinessPartners: () => Promise<void>;
  listUserEmailTemplates: () => Promise<void>;
  listAllBusinessPartnerRequest: () => Promise<void>;
  setIntervalBCBeta: () => void;
  companyId: string;
  branchCode: string;
  allCompanies: CompanyInfo[];
  companyIdRef: MutableRefObject<string>;
  branchCodeRef: MutableRefObject<string>;
  openMailAttachments: boolean;
  setOpenMailAttachments: StateDispatch<boolean>;
  GetCommunicationTypeDetailsForTool: (row) => void;
  showLoadPartnerRepliesModal: boolean;
  setShowLoadPartnerRepliesModal: StateDispatch<boolean>;
  appliedFilters: BcNewFilterType;
  setAppliedFilters: StateDispatch<BcNewFilterType>;
  appliedFiltersMailing: BcNewFilterType;
  setAppliedFiltersMailing: StateDispatch<BcNewFilterType>;
  allBranches: BranchInfo[];
  ListBranchesForCompany: any;
  lastSelectedCompanyRef: MutableRefObject<CompanyInfo>;
  lastSelectedBranchRef: MutableRefObject<BranchInfo>;
}

export const TABS_MAP = {
  responseReceived: {
    index: 0,
    label: "Response Received",
  },
  responseNotReceived: {
    index: 1,
    label: "Response Not Received",
  },
  allMails: {
    index: 2,
    label: "All Mails",
  },
} as const;

type StateDispatch<T = any> = React.Dispatch<React.SetStateAction<T>>;

const BcNewContext = createContext<IBcNewContext>({} as IBcNewContext);

export default BcNewContext;
